/* eslint-disable camelcase */
import { Component, Mixins } from 'vue-property-decorator'
import { ModuleOperationGuardMixin } from '@/api/operations/mixins/guards/module-operation-guard.mixin'
import { PortionOperation } from '@/api/operations/models/portion-operation'

@Component
export class PortionOperationGuardMixin extends Mixins(ModuleOperationGuardMixin) {
    /// GUARD OPERATIONS ///

    $_canCreatePortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.CREATE)
    }
    $_canEditPortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.EDIT)
    }
    $_canDeletePortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.DELETE)
    }

    $_canPrintPortionCassette(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.PRINT_CASSETTE)
    }
    $_canAttachDocumentToPortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.ATTACH)
    }

    $_canUndoLastPortionOperation(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.UNDO)
    }
    $_canCancelPortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.CANCEL)
    }

    $_canCutPortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.CUT)
    }
    $_canMarkPortionAsDepleted(): boolean {
        return this.$_canAccessArchive() ||
            (this.$_canAccessLaboratory() && this.$_canCutPortion())
    }

    $_canRequestRemakePortion(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.REQUEST_REMAKE)
    }
    $_canRequestAnyPortionRevision(): boolean {
        // add here new portion revision types
        return this.$_canRequestRemakePortion()
    }

    $_canTakeOutFromLaboratory(): boolean {
        return this.$_hasOperationInCurrentLaboratory(PortionOperation.TAKE_OUT_FROM_LABORATORY)
    }

    /// CAN BE ///

    $_canBeAssayRequestedToPortion(portion: any): boolean {
        return portion?.metadata?.operationGuards.canAssaysBeRequested
    }
    $_canBePortionCancelled(portion: any): boolean {
        return portion?.metadata?.operationGuards.canBeCancelled
    }
    $_canBePortionDeleted(portion: any): boolean {
        return portion?.metadata?.operationGuards.canBeDeleted
    }
    $_canBePortionVerified(portion: any): boolean {
        return portion?.metadata?.operationGuards.canBeVerified
    }
    $_canBePortionCassettePrinted(portion: any): boolean {
        return portion?.metadata?.operationGuards.canBePrinted
    }
    $_canBeIncidentCreatedToPortion(portion: any): boolean {
        return portion?.metadata?.operationGuards.canCreateIncidents
    }
    $_canBeDocumentAttachedToPortion(portion: any): boolean {
        return portion?.metadata?.operationGuards.canBeAttached
    }

    /// DISABLED ///

    $_disabledFragmentOrientation(portion: any): boolean {
        const isEditionDisabledField = portion?.metadata?.editionDisabledFields.fragmentOrientation
        return isEditionDisabledField || !this.$_canEditPortion()
    }
    $_disabledFragments(portion: any): boolean {
        const isEditionDisabledField = portion?.metadata?.editionDisabledFields.fragments
        return isEditionDisabledField || !this.$_canEditPortion()
    }
    $_disabledNotes(portion: any): boolean {
        const isEditionDisabledField = portion?.metadata?.editionDisabledFields.notes
        return isEditionDisabledField || !this.$_canEditPortion()
    }
    $_disabledPortionType(portion: any): boolean {
        const isEditionDisabledField = portion?.metadata?.editionDisabledFields.portionType
        return isEditionDisabledField || !this.$_canEditPortion()
    }
    $_disabledTissueProcessor(portion: any): boolean {
        const isEditionDisabledField = portion?.metadata?.editionDisabledFields.tissueProcessor
        return isEditionDisabledField || !this.$_canEditPortion()
    }

    $_disabledDeletePortions(portions: any[]): boolean {
        return portions?.every(portion => !this.$_canBePortionDeleted(portion)) ||
            !this.$_canDeletePortion()
    }
    $_disabledPrintPortionsCassette(portions: any[]): boolean {
        return portions?.every(portion => !this.$_canBePortionCassettePrinted(portion)) ||
            !this.$_canPrintPortionCassette()
    }
    $_disabledVerifyPortions(portions: any[]): boolean {
        return portions?.every(portion => !this.$_canBePortionVerified(portion))
    }
}
